import axios from 'axios';
import { set_system_settings, fetch_system_settings } from '../reducers/actions';

export const fetchSystemSettings = () => async (dispatch) => {
  dispatch(fetch_system_settings());
  
  try {
    const { data } = await axios.get('/api/common/terms');
    dispatch(set_system_settings(data));
  } catch (error) {
    console.error("Error fetching system settings:", error);
  }
}; 